/**
 * Module definition houses all application routes
 *
 * @module routes
 */

angular.module('routes', [
  'routes.PayloadResolver',
  'routes.MainController',
  'routes.cases',
  'routes.documentation',
  'routes.endpoints',
  'routes.error',
  'routes.export',
  'routes.import',
  'routes.login',
  'routes.magic',
  'routes.publish',
  'routes.reports',
  'routes.globalreports',
  'routes.simulation',
  'routes.users'
]).config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes', {
          url: null,
          templateUrl: 'routes/routes.html',
          resolve: {
            newmanPayload: ['PayloadResolver', function (PayloadResolver) {
              return new PayloadResolver();
            }]
          },
          controller: 'MainController'
        }
      );
    }
  ]
);
